<template>
  <div class="hb-bab-stepper mt-3" id="hb-bab-stepper">
    <v-stepper v-model="step" elevation="0" alt-labels>
      <v-stepper-header>
        <v-stepper-step class="caption" step="1"> Build a Box </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step class="caption" step="2"> Add-On </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step class="caption" step="3"> Message </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step class="caption" step="4"> Recipient </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step class="caption" step="5"> Done </v-stepper-step>
      </v-stepper-header>
    </v-stepper>
    <div class="px-6">
      <component :is="stepComponents[step-1]"></component>
    </div>
    <product-dialog :boxContentType="currentContentType"></product-dialog>
  </div>
</template>

<script>
import {TYPE_SET_STEP, TYPE_SET_GIFT_BOXES, TYPE_SET_GIFTS, TYPE_SET_CATEGORIES, TYPE_SET_ADDONS, TYPE_SET_PRODUCT_DETAILS, TYPE_SET_GIFT_CARDS} from "../../store/mutations"
import ProductDialog from './ProductDialog.vue';

const BoxGift = ()=>import("./BoxGift.vue");
const AddOns =()=>import("./AddOns.vue");
const CreateCard = () =>import('./CreateCard.vue')
const Recipient = () => import('./Recipient.vue')
const ReceiptSummary = () => import(/* webpackChunkName: "receipt-summary" */ './ReceiptSummary.vue');
export default {
  name: "hb-bab-stepper",
  props:{
    giftBoxes: Array,
    gifts: Array,
    categories: Array,
    addons: Array,
    productDetails: Object,
    giftCards: Array
  },
  components: {
    BoxGift,
    AddOns,
    CreateCard,
    Recipient,
    ReceiptSummary,

    ProductDialog
  },
  data() {
    return {
      stepComponents: ["BoxGift" ,"AddOns", "CreateCard", "Recipient", "ReceiptSummary"],
    };
  },
  methods:{
    modifyBox(amount){
      this.$store.dispatch(ACTION_MODIFY_BOX, {product: this.giftData, amount, boxContentType: this.addOn?'boxAddons':'boxContent'})
    }
  },
  computed: {
    step: {
      get() {
        return this.$store.state.step;
      },
      set(value) {
        this.$store.commit(TYPE_SET_STEP, value);
      },
    },
    substep() {
      return this.$store.state.substep;
    },
    currentContentType(){
      if(this.stepComponents[this.step-1] == 'BoxGift' && this.substep == 1)
        return 'boxType';

      if(this.stepComponents[this.step-1] == 'BoxGift' && this.substep == 3)
        return 'boxContent';

      if(this.stepComponents[this.step-1] == 'AddOns' && this.substep == 3)
        return 'boxAddons';
    }
  },
};
</script>

<style scoped>
.v-divider{
  margin: 35px -40px 0 !important;
}

.v-stepper__step__step{
  font-size: 1rem !important;
}
</style>